export const pageReplaced = (data, preventScroll = false): void => {
  // SCROLL TOP
  if (!preventScroll) {
    window.scrollTo(0, 0);
  }
  // HEADER NAV
  const siteHeader = document.querySelector('header');
  const activeItem = siteHeader && siteHeader.querySelector('.item.active');
  if (siteHeader) siteHeader.classList.remove('active');
  if (activeItem) activeItem.classList.remove('active');
  // CLASSES HTML
  const siteHtml = document.querySelector('html');
  const cla = siteHtml && [...siteHtml.classList];
  if (cla && cla.length) {
    const match = cla.find((v) => v.includes('page'));
    siteHtml.classList.remove(match);
  }

  siteHtml.removeAttribute('page-type');
  if (data.page_type) {
    siteHtml.setAttribute('page-type', data.page_type);
  }
  if (data.page_class) {
    siteHtml.classList.add(...data.page_class.split(' '));
  }
  // CLOSE DRAWER
  const event = new CustomEvent('drawer_close');
  window.dispatchEvent(event);
};
